// D183.2 - what the vendor bills still being entered say a client invoice's lines cost (provisional, read-only).
// Typed over lib/apiClient.
import { get } from './apiClient';

/** One line's cost from the bill(s) not yet confirmed. Never stored; the line's own cost changes only on Confirm & sync. */
export interface EnteredCost {
  lineNumber: number;
  /** Per invoice unit, in the invoice's currency, VAT-inclusive (the basis of `actualUnitCost`). */
  unitCost: number;
  /** Quantity on the entered bill(s), in the invoice line's unit; null when the bills' unit is not the line's. */
  qty: number | null;
  /** Vendor invoice numbers, for the tag tooltip. */
  invoiceNumbers: string[];
}

/**
 * A line with an entered bill on its costed trail that gets no cost, one entry per LINE. `code`: PO_FX_RATE_NOT_PINNED or
 * PO_CURRENCY_NOT_CONVERTIBLE (the error carries no bill id, so no bill is blamed), ENTERED_COST_PO_LINE_GONE or
 * ENTERED_COST_UNRESOLVED. `invoiceNumbers`: the entered bills on that line's trail (may be empty, never '').
 */
export interface UnavailableEnteredLine {
  lineNumber: number;
  code: string;
  invoiceNumbers: string[];
}

export interface LiveProgress {
  entered: EnteredCost[];
  unavailable: UnavailableEnteredLine[];
}

export async function fetchLiveProgress(id: string): Promise<LiveProgress> {
  const res = await get<{ success: boolean; data: LiveProgress }>(`/client-invoices/${encodeURIComponent(id)}/live-progress`);
  return res.data;
}
